// extracted by mini-css-extract-plugin
export default {"sectionSixDiv":"SectionSix_sectionSixDiv__g27MV","contDiv":"SectionSix_contDiv__aibvy"};